import * as Bixby from './../../core';
import { AppState } from './..';
import {
  RESET_PASSWORD_INPROGESS,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  VERIFY_RESET_PASSWORD_INPROGESS,
  VERIFY_RESET_PASSWORD_SUCCESS,
  VERIFY_RESET_PASSWORD_FAILURE,
} from './types';
import { FORGOT_PASSWORD_SENT_MESSAGE } from '$/core/constants';
import { ThunkAction } from 'redux-thunk';
import { UserClientService } from '$/services';

export const verifyResetPasswordRequestInProgress = () => {
  return {
    type: VERIFY_RESET_PASSWORD_INPROGESS,
  };
};

export const verifyResetPasswordRequestSuccess = (resetPasswordVerified: boolean) => {
  return {
    type: VERIFY_RESET_PASSWORD_SUCCESS,
    payload: resetPasswordVerified,
  };
};

export const verifyResetPasswordRequestFailure = (error: Bixby.Models.BixbyError) => {
  return {
    type: VERIFY_RESET_PASSWORD_FAILURE,
    payload: error,
    error: true,
  };
};

export const resetPasswordRequestInProgress = () => {
  return {
    type: RESET_PASSWORD_INPROGESS,
  };
};

export const resetPasswordRequestFailure = (error: Bixby.Models.BixbyError) => {
  return {
    type: RESET_PASSWORD_FAILURE,
    payload: error,
  };
};

export const resetPasswordRequestSuccess = (successMessage: string) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: successMessage,
  };
};

// thunk actions
const handleResetPasswordError =
  (error: Bixby.Models.BixbyError): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(resetPasswordRequestFailure(error));
  };

const handleResetPasswordSuccess =
  (successMessage: string): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> =>
  async dispatch => {
    dispatch(resetPasswordRequestSuccess(successMessage));
  };

export const resetPasswordRequest = (
  resetPasswordRequest: Bixby.Models.ResetPasswordRequest
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(resetPasswordRequestInProgress());
    try {
      await UserClientService.resetPassword(resetPasswordRequest);
      dispatch(handleResetPasswordSuccess(FORGOT_PASSWORD_SENT_MESSAGE));
    } catch (error: any) {
      dispatch(handleResetPasswordError(error));
    }
  };
};

export const verifyResetPasswordRequest = (
  verifyResetPasswordRequest: Bixby.Models.VerifyPasswordResetTokenRequest
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => {
  return async dispatch => {
    dispatch(verifyResetPasswordRequestInProgress());
    try {
      const resetPasswordVerified = await UserClientService.verifyPasswordResetToken(verifyResetPasswordRequest);
      dispatch(verifyResetPasswordRequestSuccess(resetPasswordVerified));
    } catch (error: any) {
      dispatch(verifyResetPasswordRequestFailure(error));
    }
  };
};
